var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncomingLcrBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1562_8717)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1562_8717)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1562_8717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3999 0.400391H9.5999C4.51888 0.400391 0.399902 4.51937 0.399902 9.60039V70.4004C0.399902 75.4814 4.51888 79.6004 9.5999 79.6004H70.3999C75.4809 79.6004 79.5999 75.4814 79.5999 70.4004V9.60039C79.5999 4.51937 75.4809 0.400391 70.3999 0.400391Z",
    fill: "#F8FBFF",
    stroke: "#F0F2F5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4713 20H37.8052V28.6907H46.4713V20Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7767 28.6906V27.0521H46.0358L45.6345 26.3184L45.2329 27.0521H45.492V28.6906H45.7767Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6299 28.6906V27.0521H44.889L44.4877 26.3184L44.0864 27.0521H44.3455V28.6906H44.6299Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9377 20H41.3389V28.6907H42.9377V20Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5364 20H28.8706V28.6907H37.5364V20Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8417 28.6906V27.0521H37.1008L36.6995 26.3184L36.2979 27.0521H36.5573V28.6906H36.8417Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6946 28.6906V27.0521H35.9533L35.552 26.3184L35.1504 27.0521H35.4095V28.6906H35.6946Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0026 20H32.4038V28.6907H34.0026V20Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6013 20H19.9355V28.6907H28.6013V20Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9066 28.6906V27.0521H28.1657L27.7644 26.3184L27.3628 27.0521H27.6219V28.6906H27.9066Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7601 28.6906V27.0521H27.0189L26.6176 26.3184L26.2163 27.0521H26.4754V28.6906H26.7601Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0672 20H23.4688V28.6907H25.0672V20Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4718 28.9219H37.8057V37.6122H46.4718V28.9219Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7767 37.6122V35.9736H46.0358L45.6345 35.2402L45.2329 35.9736H45.492V37.6122H45.7767Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6299 37.6122V35.9736H44.889L44.4877 35.2402L44.0864 35.9736H44.3455V37.6122H44.6299Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9382 28.9219H41.3394V37.6122H42.9382V28.9219Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5364 28.9219H28.8706V37.6122H37.5364V28.9219Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8417 37.6122V35.9736H37.1008L36.6995 35.2402L36.2979 35.9736H36.5573V37.6122H36.8417Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6946 37.6122V35.9736H35.9533L35.552 35.2402L35.1504 35.9736H35.4095V37.6122H35.6946Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0026 28.9219H32.4038V37.6122H34.0026V28.9219Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6008 28.9219H19.9351V37.6122H28.6008V28.9219Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9061 37.6122V35.9736H28.1652L27.7639 35.2402L27.3623 35.9736H27.6214V37.6122H27.9061Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7597 37.6122V35.9736H27.0184L26.6171 35.2402L26.2158 35.9736H26.4749V37.6122H26.7597Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0672 28.9219H23.4688V37.6122H25.0672V28.9219Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4718 37.8438H37.8057V46.5344H46.4718V37.8438Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7767 46.5337V44.8955H46.0358L45.6345 44.1621L45.2329 44.8955H45.492V46.5337H45.7767Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6294 46.5337V44.8955H44.8885L44.4872 44.1621L44.0859 44.8955H44.345V46.5337H44.6294Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9382 37.8438H41.3394V46.5344H42.9382V37.8438Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5364 37.8438H28.8706V46.5344H37.5364V37.8438Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8417 46.5337V44.8955H37.1008L36.6995 44.1621L36.2979 44.8955H36.5573V46.5337H36.8417Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6951 46.5337V44.8955H35.9538L35.5525 44.1621L35.1509 44.8955H35.41V46.5337H35.6951Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0026 37.8438H32.4038V46.5344H34.0026V37.8438Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6013 37.8438H19.9355V46.5344H28.6013V37.8438Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9066 46.5337V44.8955H28.1657L27.7644 44.1621L27.3628 44.8955H27.6219V46.5337H27.9066Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7597 46.5337V44.8955H27.0184L26.6171 44.1621L26.2158 44.8955H26.4749V46.5337H26.7597Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0677 37.8438H23.4692V46.5344H25.0677V37.8438Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6663 20H11.0005V28.6907H19.6663V20Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9717 28.6906V27.0521H19.2308L18.8292 26.3184L18.4282 27.0521H18.6873V28.6906H18.9717Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8246 28.6906V27.0521H18.0837L17.6821 26.3184L17.2808 27.0521H17.5399V28.6906H17.8246Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1325 20H14.5337V28.6907H16.1325V20Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6663 28.9219H11.0005V37.6122H19.6663V28.9219Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9717 37.6122V35.9736H19.2308L18.8292 35.2402L18.4282 35.9736H18.6873V37.6122H18.9717Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8246 37.6122V35.9736H18.0837L17.6821 35.2402L17.2808 35.9736H17.5399V37.6122H17.8246Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1325 28.9219H14.5337V37.6122H16.1325V28.9219Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6663 37.8438H11.0005V46.5344H19.6663V37.8438Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9722 46.5337V44.8955H19.2313L18.8296 44.1621L18.4287 44.8955H18.6878V46.5337H18.9722Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8246 46.5337V44.8955H18.0837L17.6821 44.1621L17.2808 44.8955H17.5399V46.5337H17.8246Z",
    fill: "#FFD4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1325 37.8438H14.5337V46.5344H16.1325V37.8438Z",
    fill: "#FFC766"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0005 50.1195H69.9486V49.0115L66.4652 43.5156H11.0005V50.1195Z",
    fill: "#2B4361"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4185 50.7441C24.9744 50.7441 27.0465 52.8162 27.0465 55.3725C27.0465 57.9283 24.9744 60.0004 22.4185 60.0004C19.863 60.0004 17.7905 57.9287 17.7905 55.3725C17.7905 52.8162 19.863 50.7441 22.4185 50.7441Z",
    fill: "#2B4361"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4184 52.5664C23.9678 52.5664 25.2236 53.8222 25.2236 55.3716C25.2236 56.9209 23.9674 58.1767 22.4184 58.1767C20.8691 58.1767 19.6133 56.9209 19.6133 55.3716C19.6133 53.8222 20.8691 52.5664 22.4184 52.5664Z",
    fill: "#3DB0C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 56.3758H17.2612C17.198 56.0504 17.1647 55.7147 17.1647 55.3714C17.1647 52.47 19.5166 50.1178 22.4179 50.1178C25.3193 50.1178 27.6715 52.47 27.6715 55.3714C27.6715 55.7147 27.6382 56.0504 27.5753 56.3758H57.4377C57.3748 56.0504 57.3415 55.7147 57.3415 55.3714C57.3415 52.47 59.6937 50.1178 62.5947 50.1178C65.4961 50.1178 67.8483 52.47 67.8483 55.3714C67.8483 55.7147 67.8146 56.0504 67.7521 56.3758H69.9485V49.0098H11V56.3758Z",
    fill: "#2B4361"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5948 50.7441C65.151 50.7441 67.2227 52.8162 67.2227 55.3725C67.2227 57.9283 65.151 60.0004 62.5948 60.0004C60.0392 60.0004 57.9668 57.9287 57.9668 55.3725C57.9671 52.8162 60.0392 50.7441 62.5948 50.7441Z",
    fill: "#2B4361"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5948 52.5664C64.1442 52.5664 65.4 53.8222 65.4 55.3716C65.4 56.9209 64.1438 58.1767 62.5948 58.1767C61.0459 58.1767 59.79 56.9209 59.79 55.3716C59.79 53.8222 61.0459 52.5664 62.5948 52.5664Z",
    fill: "#3DB0C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.949 49.0101L68.3818 46.5371H11.0005V49.0101H69.949Z",
    fill: "#EAA123"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0297 28.6302L67.7159 45.4863H66.3267H57.03V43.5038H64.2595L57.03 32.0996V28.6302H57.0297ZM47.8096 28.291H48.7793H49.0057H56.8559V28.356L57.0297 28.6302V32.0996L55.8079 30.1718H49.8002V43.5038H57.0297V45.4863H47.8096V45.4252V44.0462V28.291Z",
    fill: "#2B4361"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8003 30.1719V43.5039H66.4648L58.0075 30.1719H49.8003Z",
    fill: "#C4F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 56.3766H17.2612C17.198 56.0511 17.1647 55.7155 17.1647 55.3721C17.1647 54.3937 17.4325 53.4777 17.8984 52.6934H11V56.3766ZM26.9377 52.6934C27.4036 53.4773 27.6715 54.3937 27.6715 55.3721C27.6715 55.7155 27.6382 56.0511 27.5753 56.3766H57.4377C57.3748 56.0511 57.3415 55.7155 57.3415 55.3721C57.3415 54.3937 57.6094 53.4777 58.0752 52.6934H26.9377ZM67.1146 52.6934C67.5805 53.4773 67.848 54.3937 67.848 55.3721C67.848 55.7155 67.815 56.0511 67.7521 56.3766H69.9485V52.6934H67.1146Z",
    fill: "#2B4361"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1562_8717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1562_8717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1562_8717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingLcrBag);
export default __webpack_public_path__ + "static/media/incomingLcrBag.7f835b6db96f6108909f5e58d5ba33c0.svg";
export { ForwardRef as ReactComponent };